/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/pemandu?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  async detail({}, payload) {
    const url = `/pemandu/${payload.id}`;
    return await http.get(url).then(({ data }) => data);
  },

  async transaksi({}, payload) {
    const url = `/pemandu/${payload.id}/transaksis?${queryString(payload.params)}`;
    return await http.get(url).then(({ data }) => data);
  },

  create({}, payload) {
    const url = `/pemandu`;
    return http.post(url, payload.params);
  },

  update({}, payload) {
    const url = `/pemandu/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/pemandu/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/pemandu/${payload.id}`;
    return http.delete(url);
  },
};
